import React from "react";
import styled from "styled-components";
import { ButtonTxtStyle } from "storybook-components/Typography";
import { ArrowLink } from "storybook-components/Link";

const StyledLink = styled(ArrowLink)`
  ${ButtonTxtStyle};
  margin: auto 32px;
  text-decoration: none;
`;

const CategoryPageLink = ({ to, className, linkText }) => (
  <>
    <StyledLink to={to} linkText={linkText} className={className} />
  </>
);

export default CategoryPageLink;
